import { render } from "./AudioDevices.vue?vue&type=template&id=0354afc1"
import script from "./AudioDevices.vue?vue&type=script&lang=js"
export * from "./AudioDevices.vue?vue&type=script&lang=js"

import "./AudioDevices.vue?vue&type=style&index=0&id=0354afc1&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__